import React from "react";

/* 카드 표면 — 색은 CSS 변수(global.js가 테마별로 정의)를 따른다.
   darkMode prop을 받지 않는 이유: 호출부가 넘기는 걸 잊으면 다크모드에서
   흰 카드가 나오기 때문. 테마 전환은 변수 한 곳에서만 일어난다. */
export default function GlassCard({ children, className = "", style = {}, ...props }) {
  return (
    <div
      className={`glass-card-modern ${className}`}
      style={{
        background: "var(--card-bg)",
        border: "1px solid var(--card-border)",
        borderRadius: 20,
        padding: "20px",
        position: "relative",
        boxShadow: "0 1px 3px var(--shadow), 0 8px 22px var(--shadow)",
        backdropFilter: "blur(16px)",
        WebkitBackdropFilter: "blur(16px)",
        transition: "background 0.4s, border-color 0.4s",
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  );
}
